import { useSelector } from 'react-redux';
import type { RootState } from '../../store';

export const ECPT_ROLES = {
  admin: 'MOPSCAS1.MOPSC-AS-ECPT-ADMINS',
  developmentTeam: 'MOPSCAS1.MOPSC-DEVELOPMENT-TEAM',
  user: 'MOPSCAS1.MOPSC-AS-ECPT-USERS',
  viewOnly: 'MOPSCAS1.MOPSC-AS-ECPT-USERS-ViewOnly',
} as const;

export interface EcptPermissions {
  hasAccess: boolean;
  isAdmin: boolean;
  isViewOnly: boolean;
  canManageSettings: boolean;
  canManageGenericFields: boolean;
  canEditGenericFieldData: boolean;
  canUseGetAction: boolean;
}

export function getEcptPermissions(groups: readonly string[] | null | undefined): EcptPermissions {
  const isAdmin = groups?.includes(ECPT_ROLES.admin) ?? false;
  const isDevelopmentTeam = groups?.includes(ECPT_ROLES.developmentTeam) ?? false;
  const isUser = groups?.includes(ECPT_ROLES.user) ?? false;
  const isViewOnly = groups?.includes(ECPT_ROLES.viewOnly) ?? false;
  const isAdminLike = isAdmin || isDevelopmentTeam;

  return {
    hasAccess: isAdminLike || isUser || isViewOnly,
    isAdmin: isAdminLike,
    isViewOnly,
    canManageSettings: isAdminLike || isUser,
    canManageGenericFields: isAdminLike,
    canEditGenericFieldData: isAdminLike || isUser,
    canUseGetAction: isAdminLike || isUser,
  };
}

export function useEcptPermissions(): EcptPermissions {
  const groups = useSelector((state: RootState) => state.ssoUser?.profile?.entitlement_group);
  return getEcptPermissions(groups);
}
